import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { getDoc } from 'firebase/firestore';
import { collection, getDocs } from 'firebase/firestore';

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  backgroundColor: '#f9fafb',
  fontFamily: `'Helvetica Neue', sans-serif`,
};

const boxStyle = {
  width: '100%',
  maxWidth: '420px',
  backgroundColor: '#ffffff',
  borderRadius: '20px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  padding: '40px',
  textAlign: 'center',
};

const inputStyle = {
  width: '100%',
  marginBottom: '16px',
  padding: '16px',
  borderRadius: '12px',
  border: '1px solid #ccc',
  backgroundColor: '#f5f5f5',
  fontSize: '16px',
  boxSizing: 'border-box', // ✅ Add this
  boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.06)',
};

const buttonStyle = {
  width: '100%',
  padding: '16px',
  backgroundColor: '#f4c542',
  color: '#000',
  border: 'none',
  borderRadius: '12px',
  fontWeight: 'bold',
  fontSize: '16px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  boxSizing: 'border-box', // ✅ Add this
};

const formGroupStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  boxSizing: 'border-box', // ✅ Add this too
};

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);

  const handleAuth = async () => {
    try {
      let userCredential;

      if (isSignUp) {
        userCredential = await createUserWithEmailAndPassword(auth, email, password);

        const user = userCredential.user;
        await setDoc(doc(db, 'users', user.uid), {
          email: user.email,
          accessTier: 'expired',
          createdAt: new Date()
        });

        alert('✅ Account created, but access is currently expired.');
        return;
      }

      // 🟡 LOGIN FLOW
      userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user; // ✅ define it first

      console.log('✅ Login successful');
      console.log('🔥 Firebase UID:', user.uid);

      localStorage.setItem('userUid', user.uid); // ✅ now it's valid
      console.log('🔑 Authenticated UID:', userCredential.user.uid);
      console.log('📧 Email:', userCredential.user.email);

      // 🔐 THIS MUST BE CORRECT — USE UID
      const userDocRef = doc(db, 'users', user.uid);
      console.log('📂 Looking for user doc at:', userDocRef.path);

      const userDocSnap = await getDoc(userDocRef);
      console.log('📄 userDocSnap.exists():', userDocSnap.exists());

      if (!userDocSnap.exists()) {
        console.log('❌ No user doc found. Dumping all users for debug...');
        
        // TEMPORARY DEBUG: List all users in the 'users' collection
        const allUsers = await getDocs(collection(db, 'users'));
        allUsers.forEach(doc => {
          console.log(`🧾 Found user doc — ID: ${doc.id}, data:`, doc.data());
        });

        console.log('🔥 ALERT TRIGGERED — falling into no user doc block!');
        alert('⛔ No user record found in Alfred. Please contact support.');
        return;
      }

      const userData = userDocSnap.data();
      console.log('🧠 userData:', userData);
      if (userData.accessTier === 'expired') {
        alert('⛔ Access is currently expired. Please contact support.');
        return;
      }
      console.log('🎉 Access granted! Proceeding to login...');

      try {
        localStorage.setItem('userEmail', user.email);
        localStorage.setItem('userUid', user.uid);
        console.log('🚀 Calling onLogin...');
        onLogin(user);
      } catch (e) {
        console.error('❌ onLogin() threw an error:', e);
        alert('Something went wrong after login.');
      }

    } catch (err) {
      console.error('Access check error:', err);
      alert('Something went wrong during access check.');
    }
  };



  const handlePasswordReset = async () => {
    if (!email) {
      alert('Please enter your email to reset your password.');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      alert('📬 Password reset email sent! Check your inbox.');
    } catch (err) {
      console.error('Reset error:', err.message);
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={boxStyle}>
        {/* Alfred wordmark */}
        <h1 style={{
          fontSize: '32px',
          fontWeight: '800',
          color: '#000',
          marginBottom: '10px',
          letterSpacing: '-0.5px',
        }}>
          Alfred
        </h1>

        {/* Optional subtitle */}
        {/* <p style={{ color: '#666', fontSize: '14px', marginBottom: '24px' }}>Your AI Sales Partner</p> */}

        <h2 style={{ marginBottom: '24px' }}>
          {isSignUp ? 'Create Your Account' : 'Login to Use Your AI Sales Butler:'}
        </h2>

        <div style={formGroupStyle}>
            <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                style={inputStyle}
            />
            <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                type="password"
                style={inputStyle}
            />

            <button
                onClick={handleAuth}
                style={buttonStyle}
                onMouseOver={(e) => (e.target.style.backgroundColor = '#e5b836')}
                onMouseOut={(e) => (e.target.style.backgroundColor = '#f4c542')}
            >
                {isSignUp ? 'Create Account' : 'Login'}
            </button>

            <button
              onClick={handlePasswordReset}
              style={{
                marginTop: '8px',
                background: 'transparent',
                border: 'none',
                color: '#0077cc',
                textDecoration: 'underline',
                fontSize: '14px',
                cursor: 'pointer'
              }}
            >
              Forgot Password?
            </button>
            </div>

        <p
          onClick={() => setIsSignUp(!isSignUp)}
          style={{
            cursor: 'pointer',
            marginTop: '20px',
            color: '#555',
            textDecoration: 'underline',
          }}
        >
          {isSignUp ? 'Already have an account? Login' : 'No account? Sign up'}
        </p>
      </div>
    </div>
  );
};

export default Login;
